import React from 'react';
import './home.css'
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter,NavLink} from 'react-router-dom'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import {setUser} from '../../redux/actions/AuthActions'
import Skeleton from 'react-loading-skeleton';
import { Line } from "react-chartjs-2";
import moment from 'moment'
import { Spin } from 'antd';
import 'moment/locale/ar';
import StatisticCard from '../../component/statisticCard/statisticCard';

class Home extends React.Component {
  state = {
    count:[],
    tops:[],
    topOfficesRate:[],
    user:[],
    loading:true,
    clients:[],
    graphAds:[],
    days:[],
    daysEN:[],
    daysAR:[],
    maxValue:0,
    graphStep:0,
    interests:[]
  }
  constructor(props){
    super(props)
    this.getCount()
    this.getTopOffices()
    this.getInterests()
    this.getGraph()
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
      moment.locale('ar');
    }else{
      allStrings.setLanguage('en')
      moment.locale('en');
    } 
  }
  getGraph = () => {
    axios.get(`${BASE_END_POINT}admin/getGraph`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data)
      let daysEN=[]
      let daysAR=[]
      response.data.days.forEach(day => {
        daysAR.push(moment(day).locale('ar').format("ll"))
        daysEN.push(moment(day).locale('en').format('MMM Do YY'))
      });
      let arr = response.data.clients
      let maxValue1 = Math.max( ...arr );
      let max = maxValue1;
      let arr2 = response.data.ads
      let maxValue2 = Math.max( ...arr2 );
      if(maxValue2 > maxValue1) max = maxValue2
      this.setState({
        loading: false,
        clients:response.data.clients,
        graphAds:response.data.ads,
        daysEN:daysEN,
        daysAR:daysAR,
        maxValue:max,
        graphStep:Math.floor(max / 10)
      })
    })
    .catch(error=>{
      console.log("ALL graph ERROR")
      console.log(error.response)
    })
  }
  getTopOffices = () => {
    axios.get(`${BASE_END_POINT}find?type=OFFICE&sort=rate`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data)
      this.setState({topOfficesRate:response.data.data})
    })
    .catch(error=>{
      console.log("ALL topOfficesRate ERROR")
      console.log(error.response)
    })
  }
  getCount = () => {
    axios.get(`${BASE_END_POINT}admin/count`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    })
    .then(response=>{
      console.log(response.data)
      this.setState({count:response.data,loading:false})
    })
    .catch(error=>{
      console.log("ALL count ERROR")
      console.log(error.response)
    })
  }
  getInterests = () => {
    axios.get(`${BASE_END_POINT}interests?page=1&limit=7`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data.data)
      this.setState({interests:response.data.data})
    })
    .catch(error=>{
      console.log("ALL interests ERROR")
      console.log(error.response)
    })
  }
  componentDidMount(){
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
      moment.locale('ar');
    }else{
      allStrings.setLanguage('en')
      moment.locale('en');
    } 
  }
  render(){
    const data = {
      labels:this.props.isRTL?this.state.daysAR:this.state.daysEN,
      datasets: [
        {
          label: allStrings.Clients,
          data: this.state.clients,
          fill: true,
          backgroundColor: 'rgba(157, 248, 255, 0.411)',
          borderColor: 'rgba(157, 248, 255, 0.411)',
          pointBorderColor:'rgba(157, 248, 255, 0.411)',
          pointBackgroundColor:'rgba(255, 255,255)',
          pointBorderWidth:5,
          yAxisID: 'y-axis-1',
          
        },
        {
          label: allStrings.ads,
          data:this.state.graphAds,
          fill: true,
          backgroundColor: 'rgba(195, 193, 252, 0.555)', 
          borderColor: 'rgba(54, 162, 235, 0.2)',
          pointBorderColor:'rgba(54, 162, 235, 0.2)',
          pointBackgroundColor:'rgba(255, 255, 255, 1)',
          pointBorderWidth:5,
          yAxisID: 'y-axis-2',
        },
      ],
    }
    const options = {
      maintainAspectRatio : false,
      responsive: true,
      legend: {
        display: true,
        position:'bottom',
        align:this.props.isRTL?'end':'start',
        labels: {
            fontColor: '#000',
            borderRadius:'4px',
            boxWidth:20,
            padding:20,
        }
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            display: true,
            stacked: true,
            position: 'left',
            id: 'y-axis-1',
            ticks: {
              max: this.state.maxValue,
              min: 0,
              stepSize: this.state.graphStep
            },
            barPercentage: 1,
            offsetGridLines: false,
            gridLines: {
              offsetGridLines: false,
              display: true,
              color: "#F0F2F5",
              borderStyle:'dashed'
            },
          },
          {
            type: 'linear',
            display: false,
            position: 'right',
            id: 'y-axis-2',
            ticks: {
              max: this.state.maxValue,
              min: 0,
              stepSize: this.state.graphStep
            },
            barPercentage: 1,
            offsetGridLines: false,
            gridLines: {
              offsetGridLines: false,
              display: true,
              color: "#F0F2F5",
              borderStyle:'dashed'
            },
          },
        ],
      },
    }
    let {loading} = this.state;
  return (
    <div className="Home">
      <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#1D9598'}}>
      <MDBContainer> 
        <MDBRow>
         <div style={{textAlign:this.props.isRTL? 'right':'left',
         flexDirection:this.props.isRTL?'row':'row-reverse',
         display:this.props.isRTL?'': 'flex',width:this.props.isRTL?'100%': '',padding: '5px 20px 25px'}}>
          <span  style={{display: 'inline-block',color: '#43425D',fontSize:'22px'}}>{allStrings.statistic}</span>
          <span  style={{fontFamily:'Cairo',fontWeight:'bold',fontSize:'22px',display: 'inline-block',
            color: '#43425D',margin:'6px',lineHeight:this.props.isRTL?'auto':'15px'}}>|</span>
          <span style={{fontFamily:'Cairo',fontWeight:'bold',fontSize:'22px',display: 'inline-block',
            color: '#43425D'}}>{allStrings.overView}</span>
         </div>
        </MDBRow>
        <MDBRow>
          <StatisticCard
            name={this.state.count.topEmployees?this.state.count.topEmployees[0]?this.state.count.topEmployees[0].employee.fullname:"--":"--"}
            //value={this.state.count.topEmployees?this.state.count.topEmployees[0]?this.state.count.topEmployees[0].totalCost:0:0}
            value=""
            isRTL={this.props.isRTL}
            loading={loading}
            img={this.state.count.topEmployees?this.state.count.topEmployees[0]?this.state.count.topEmployees[0].employee.img:"":""}
            awardPlace={1}
          />
          <StatisticCard
            name={this.state.count.topEmployees?this.state.count.topEmployees[1]?this.state.count.topEmployees[1].employee.fullname:"--":"--"}
            //value={this.state.count.topEmployees?this.state.count.topEmployees[1]?this.state.count.topEmployees[1].totalCost:0:0}
            value=""
            isRTL={this.props.isRTL}
            loading={loading}
            awardPlace={2}
            img={this.state.count.topEmployees?this.state.count.topEmployees[1]?this.state.count.topEmployees[1].employee.img:"":""}
          />
          <StatisticCard
            name={this.state.count.topEmployees?this.state.count.topEmployees[2]?this.state.count.topEmployees[2].employee.fullname:"--":"--"}
            //value={this.state.count.topEmployees?this.state.count.topEmployees[2]?this.state.count.topEmployees[2].totalCost:0:0}
            value=""
            isRTL={this.props.isRTL}
            loading={loading}
            awardPlace={3}
            img={this.state.count.topEmployees?this.state.count.topEmployees[2]?this.state.count.topEmployees[2].employee.img:"":""}
          />
        </MDBRow>

        {this.props.currentUser.user.type === "ADMIN"&&
        <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
          <StatisticCard
            name={allStrings.usersCount}
            value={this.state.count.users}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.Offices}
            value={this.state.count.offices}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.approvedOfficesCount}
            value={this.state.count.approvedOfficesCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.ads}
            value={this.state.count.ads}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.requests}
            value={this.state.count.requestsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.interests}
            value={this.state.count.interestsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.pendingInterests}
            value={this.state.count.pendingInterestsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          {/* <StatisticCard
            name={allStrings.completedRequest}
            value={this.state.count.completedRequestsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          /> */}
          <StatisticCard
            name={allStrings.investmentsCount}
            value={this.state.count.investmentsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.contactRequestCount}
            value={this.state.count.contactRequestCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.dealsCount}
            value={this.state.count.dealsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.bookedCount}
            value={this.state.count.bookedCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.soldCount}
            value={this.state.count.soldCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.completedCount}
            value={this.state.count.completedCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.deliveredCount}
            value={this.state.count.deliveredCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.collectedCount}
            value={this.state.count.collectedCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.totalCollected}
            value={this.state.count.totalCollected}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          
          <StatisticCard
            name={allStrings.notCollectedCount}
            value={this.state.count.notCollectedCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.totalNotCollected}
            value={this.state.count.totalNotCollected}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          
          
          
          
        </MDBRow>
        }{this.props.currentUser.user.type === "SUB-ADMIN"&&
          <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
            <StatisticCard
              name={allStrings.totalInterestsCount}
              value={this.state.count.totalCount}
              isRTL={this.props.isRTL}
              loading={loading}
            />
            <StatisticCard
              name={allStrings.pendingInterestsCount}
              value={this.state.count.countPending}
              isRTL={this.props.isRTL}
              loading={loading}
            />
            <StatisticCard
              name={allStrings.countInterestedOrVisit}
              value={this.state.count.countInterestedOrVisit}
              isRTL={this.props.isRTL}
              loading={loading}
            />
            <StatisticCard
              name={allStrings.countNoReply}
              value={this.state.count.countNoReply}
              isRTL={this.props.isRTL}
              loading={loading}
            />
            <StatisticCard
              name={allStrings.countFollowUp}
              value={this.state.count.countFollowUp}
              isRTL={this.props.isRTL}
              loading={loading}
            />
            <StatisticCard
              name={allStrings.countCalled}
              value={this.state.count.countCalled}
              isRTL={this.props.isRTL}
              loading={loading}
            />
            <StatisticCard
            name={allStrings.bookedCount}
            value={this.state.count.bookedCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.dealsCount}
            value={this.state.count.dealsCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.completedCount}
            value={this.state.count.completedCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.deliveredCount}
            value={this.state.count.deliveredCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          <StatisticCard
            name={allStrings.soldCount}
            value={this.state.count.soldCount}
            isRTL={this.props.isRTL}
            loading={loading}
          />
          </MDBRow>
        }
        <br></br>
        {this.props.currentUser.user.type === "ADMIN"&&
        <MDBRow>
          <MDBCol  md="12">
            <p style={{fontFamily: 'Cairo',background:' #fff',marginBottom: '0px',padding: '18px 22px',
                fontWeight: '600',color: '#43425D',fontSize: '17px',textAlign: this.props.isRTL?'right':'left'
            }}>{allStrings.statistic}</p>
            <div className="homeChart">
              <Line height="400px" data={data} options={options} />
            </div>
          </MDBCol>
        </MDBRow>
        }
        <br></br>
        <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
          <MDBCol xl="12" lg="12" md="12" sm="12">
            <div className="theCard" style={{minHeight:'505px'}}>
              <p className="topCard" style={{color: '#43425D',textAlign: this.props.isRTL?'right':'left'}}>{allStrings.requests}</p>
              <br></br>
              <table className="table table-borderless">
                <thead className="thead-light">
                  <tr >
                    <th scope="col">{allStrings.date}</th>
                    <th scope="col">{allStrings.status}</th>
                    <th scope="col">{allStrings.phone}</th>
                    <th scope="col">{allStrings.fullname}</th>
                  </tr>
                </thead>
                <tbody>
                {this.state.loading?
                <div style={{width:"100%"}} >
                  <Skeleton height={40} /> 
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                </div>
                :
                this.state.interests.length > 0 ?
                  this.state.interests.map(val=>(
                      <tr onClick={()=>this.props.history.push("/interestInfo",{data:val})}>
                        <th>{moment(val.createdAt).format("dddd D MMMM YYYY hh:mm A")}</th>
                        <th><p className='tag' style={{width:'90px'}}>{val.status==="PENDING"?allStrings.pending:val.status==="CONTACT-PHASE"?allStrings.contactPhase:val.status==="VISITING-PHASE"?allStrings.visitingPhase:val.status==="CLOSED"?allStrings.closed:allStrings.contactDone}</p></th>
                        <td>{val.phone}</td>
                        <td>{val.fullname?val.fullname.substr(0,15):"-"}</td>
                      </tr>
                  ))
                  :
                  <tr style={{height: '300px'}}>
                      <th colSpan="8" className="noData" style={{background:"#fff"}}>
                      <p style={{marginTop:'10rem',textAlign:'center',}}>{allStrings.noData}</p> 
                      </th>
                  </tr>
                }
                </tbody>
              </table>
              <hr></hr>
              <NavLink to="interests">
                <span style={{display:'block',marginBottom:'8px'}}>{allStrings.showAll}</span>
              </NavLink>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer> 
      </Spin>
    </div> 
  )
  }
}
const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})
const mapDispatchToProps = {
  setUser,
  ChangeLanguage
}
export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(Home)
);